"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _I18n = _interopRequireDefault(require("I18n"));

var _omit = _interopRequireDefault(require("transmute/omit"));

var _immutable = require("immutable");

var _PropertyRecord = _interopRequireDefault(require("customer-data-objects/property/PropertyRecord"));

var PropertyValueDisplay = _interopRequireWildcard(require("customer-data-property-utils/PropertyValueDisplay"));

var _UISelect = _interopRequireDefault(require("UIComponents/input/UISelect"));

var propTypes = {
  defaultValue: _react.PropTypes.node,
  onBlur: _react.PropTypes.func,
  onChange: _react.PropTypes.func,
  onFocus: _react.PropTypes.func,
  property: _react.PropTypes.instanceOf(_PropertyRecord.default).isRequired,
  showPlaceholder: _react.PropTypes.bool,
  value: _react.PropTypes.node,
  isRequired: _react.PropTypes.bool
};

var PropertyInputEnum =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(PropertyInputEnum, _React$Component);

  function PropertyInputEnum() {
    (0, _classCallCheck2.default)(this, PropertyInputEnum);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(PropertyInputEnum).apply(this, arguments));
  }

  (0, _createClass2.default)(PropertyInputEnum, [{
    key: "focus",
    value: function focus() {
      return this.refs.input.focus();
    }
  }, {
    key: "getPlaceholder",
    value: function getPlaceholder() {
      var _this$props = this.props,
          property = _this$props.property,
          showPlaceholder = _this$props.showPlaceholder;

      if (!showPlaceholder) {
        return '';
      }

      return property.placeholder || _I18n.default.text('customerDataProperties.PropertyInput.selectPlaceholder');
    }
  }, {
    key: "getValue",
    value: function getValue() {
      var value = this.props.value || this.props.defaultValue;
      var result = String(value || '');
      return result;
    }
  }, {
    key: "render",
    value: function render() {
      var transferableProps = (0, _omit.default)(['aria-required', 'autoFocus', 'baseUrl', 'data-field', 'error', 'id', 'isInline', 'getProperty', 'objectType', 'onCancel', 'onFocus', 'onInvalidProperty', 'onKeyUp', 'onSecondaryChange', 'propertyIndex', 'readOnly', 'readOnlySourceData', 'required', 'secondaryChanges', 'showError', 'subject', 'subjectId', 'onTracking', 'isRequired'], (0, _immutable.Seq)(this.props)).toJS();
      var options = this.props.isRequired ? PropertyValueDisplay.makeOptionsFromPropertyWithoutBlankOptions(this.props.property) : PropertyValueDisplay.makeOptionsFromProperty(this.props.property);
      return _react.default.createElement(_UISelect.default, (0, _extends2.default)({}, transferableProps, {
        options: options,
        placeholder: this.getPlaceholder(),
        ref: "input",
        value: this.getValue()
      }));
    }
  }]);
  return PropertyInputEnum;
}(_react.default.Component);

exports.default = PropertyInputEnum;
PropertyInputEnum.propTypes = propTypes;
module.exports = exports.default;